<template>
  <v-container
    id="register"
    class="fill-height"
    tag="section"
  >
    <v-snackbar
      v-if="loginResponse"
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      <v-card
        color="orange"
        flat
      >
        <v-card-text>
          {{ alertmessage }}
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="white"
            outlined
            @click="resetErrorResponse"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-snackbar>
    <v-row justify="center">
      <v-col cols="12">
        <v-slide-y-transition appear>
          <v-card
            class="pa-3 pa-md-5 mx-auto"
            light
            max-width="770"
          >
            <pages-heading class="text-center">
              Welcome to Paythings. Register for Group: {{ grouplink }}
            </pages-heading>

            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-row no-gutters>
                  <v-col
                    v-for="(section, i) in sections"
                    :key="i"
                    cols="12"
                  >
                    <v-list-item three-line>
                      <v-list-item-icon class="mr-4 mt-5 mt-md-4">
                        <v-icon
                          :large="$vuetify.breakpoint.mdAndUp"
                          :color="section.iconColor"
                          v-text="section.icon"
                        />
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title
                          class="title font-weight-light mb-4 mt-1"
                          v-text="section.title"
                        />

                        <v-list-item-subtitle v-text="section.text" />
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-col>

              <v-col
                cols="12"
                md="6"
              >
                <div class="text-center">
                  <div class="my-2" />

                  <div class="text-center grey--text body-1 font-weight-light">
                    Your Information
                  </div>
                  <v-form
                    ref="form"
                    v-model="valid"
                  >
                    <v-text-field
                      v-model="email"
                      color="secondary"
                      label="Email..."
                      :rules="emailRules"
                      prepend-icon="mdi-email"
                    />
                    <v-text-field
                      v-model="password"
                      color="secondary"
                      label="Password..."
                      type="password"
                      :rules="passwordrules"
                      prepend-icon="mdi-lock-outline"
                    />
                    <v-text-field
                      v-model="repeatPassword"
                      color="secondary"
                      name="repeatPassword"
                      type="password"
                      :rules="[comparePasswords]"
                      label="Confirm Password..."
                      prepend-icon="mdi-lock-outline"
                    />
                    <v-checkbox
                      :input-value="true"
                      color="secondary"
                    >
                      <template v-slot:label>
                        <span class="text-no-wrap">I agree to the&nbsp;</span>

                        <a
                          class="secondary--text ml-6 ml-sm-0"
                          href="#"
                        >
                          terms and conditions
                        </a>.
                      </template>
                    </v-checkbox>

                    <pages-btn
                      :disabled="!valid"
                      @click="submit()"
                    >
                      Register
                    </pages-btn>
                  </v-form>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'PagesRegister',

    components: {
      PagesBtn: () => import('./components/Btn'),
      PagesHeading: () => import('./components/Heading')
    },
    data: () => ({
      snackbar: false,
      timeout: 0,
      alertmessage: '',
      group: '',
      valid: true,
      repeatPassword: '',
      password: '',
      mobile: '',
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      passwordrules: [
        v => !!v || 'Passowrd is required',
        v => (v && v.length <= 10) || 'Password must be less than 10 characters',
        v => (v && v.length >= 5) || 'Password must be at least 6 characters',
      ],
      mobilerules: [
        v => !!v || 'Mobile is required',
        v => (v && v.length >= 7) || 'Password must be at least 7 characters',
      ],
      sections: [
        {
          icon: 'mdi-account-check',
          iconColor: 'primary',
          title: 'Location Monitoring',
          text: `Get real time alerts and updates`
        },
        {
          icon: 'mdi-map',
          iconColor: 'secondary',
          title: 'Add locations',
          text: `Add locations and keep track of your estate`
        },
        {
          icon: 'mdi-flash',
          iconColor: 'cyan',
          title: 'Monitor Safe Statuses',
          text: 'Real time monitoring of balances, deposits, cash pick ups. '
        }
      ],
      socials: [
        {
          href: '#',
          icon: 'mdi-facebook-box',
          iconColor: '#3B5998'
        },
        {
          href: '#',
          icon: 'mdi-twitter',
          iconColor: '#1DA1F2'
        },
        {
          href: '#',
          icon: 'mdi-github-box',
          iconColor: '#24292E'
        }
      ]
    }),
    computed: {
      grouplink () {
        console.log(this.$route.params.group)
        return this.$route.params.group
      },
      loginResponse () {
        if (this.$store.getters.getloginerror) {
          this.snackbar = true
          this.alertmessage = this.$store.getters.getloginerror
        }
        return this.$store.getters.getloginerror
      },
      comparePasswords () {
        if (this.password !== this.repeatPassword) {
          return false
        }
        return true
      },
    },
    created () {
      console.log(this.$route.params)
      this.group = this.$route.params.group
    },
    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      resetErrorResponse () {
        this.$store.dispatch('clearLoginResponse')
        this.alertmessage = ''
        this.snackbar = false
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      onDismissed () {
        this.$store.dispatch('clearError')
      },
      submit () {
        this.checking = true

        this.$store.dispatch('signUserUpGroup', {
          group: this.group,
          email: this.email.trim(),
          password: this.password
        })
        let errorstate = this.$store.getters.error
        /*
        setTimeout(() => {
          if (this.$store.getters.user) {
            console.log('WE HAVE A USER TO SEND HOME ', this.$store.getters.user)
            this.snackbar = true
            this.resetForm()
            this.$v.$reset()
            this.$router.push({
              name: 'dashboard/Dashboardv2'
            })
          }
        }, 5000)
        */
        this.checking = false
      }
    }
  }
</script>

<style lang="sass">
  #register
    .v-list-item__subtitle
      -webkic-line-clamp: initial
      -webkit-box-orient: initial
</style>
